<template>
  <ul class="infos-list">
    <li
      v-for="(info, i) in infos"
      :key="i"
      class="infos-list__item p"
      :class="isDesktop ? 'p--4' : 'p--2'"
    >
      <span class="infos-list__text" v-html="info.value" />
    </li>
  </ul>
</template>

<script setup lang="ts">

  defineProps<{
    infos: {
      value: string | number;
    }[];
  }>()

  const viewport = useViewport()
  const isDesktop = computed(() => viewport.isGreaterThan('md'))
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiReset' as *;

  .infos-list {
    @include ulres;

    @include media(md-max) {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    @include media(lg) {
      padding: 16px 20px;
    }
  }

  .infos-list__item {
    position: relative;

    &:not(:last-child) {
      margin-bottom: 6px;
    }

    &::before {
      position: absolute;
      top: 10px;
      left: 0;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: var(--text-main-color);
      content: '';
    }
  }

  .infos-list__text {
    padding-left: 16px;

    @include media(lg) {
      display: inline-block;
    }
  }
</style>
